;(async () => {
  if (!customElements.get('product-card-swiper')) {
    const { default: Swiper, Navigation } = await import('swiper')

    Swiper.use([Navigation])

    class ProductCard extends HTMLElement {
      constructor() {
        super()

        this.swiperElement = this.querySelector('[data-swiper-product-card]')
        this.hiddenClass = 'hidden'

        this.swiperOptions = {
          loop: false,
          autoplay: false,
          threshold: 5,
          touchAngle: 25,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          slidesPerView: 1,
          direction: 'horizontal',
          on: {
            afterInit: () => {
              this.querySelectorAll('button').forEach((button) => button.classList.remove(this.hiddenClass))
            },
          },
        }

        // Check if we have extra options on the HTML
        if (this && this.dataset && this.dataset.options) {
          const jsonOptions = JSON.parse(this.dataset.options)

          if (jsonOptions) {
            this.swiperOptions = {
              ...this.swiperOptions,
              ...jsonOptions,
            }
          }
        }

        // Init
        this.init()

        // On resize event
        window.addEventListener(
          'resize',
          debounce(() => {
            this.init()
          }, 200).bind(this),
        )
      }

      init() {
        const windowWidth = window.innerWidth

        if (windowWidth < 768) {
          this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions)
        } else if (this.swiperInstance) {
          this.querySelectorAll('button').forEach((button) => button.classList.add(this.hiddenClass))
        }
      }
    }

    window.ProductCard = ProductCard

    customElements.define('product-card-swiper', ProductCard)
  }
})()
